// extracted by mini-css-extract-plugin
export var cardSelected = "_i1-2";
export var image = "_i1-1";
export var table = "_i1-0";